import { FC } from "react";
import { ResolvedTeamReference } from "../../../../Components/ResolvedTeamReference";
import { ActionIcon, Anchor, Badge, Box, Flex, Table } from "@mantine/core";
import { components } from "../../../../openapi/generated-types";
import { DateTime } from "luxon";
import { IconBrandYoutube, IconPhoto } from "@tabler/icons-react";
import { TeamLogo } from "../../../../Components/TeamLogo";
import { Link } from "react-router-dom";

interface GameListProps {
  games: components["schemas"]["Game"][];
}

export const GameList: FC<GameListProps> = (props) => {
  const { games } = props;

  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          <Table.Th style={{ width: "1%" }}>#</Table.Th>
          <Table.Th style={{ width: "1%" }}>Zeit</Table.Th>
          <Table.Th>Paarung</Table.Th>
          <Table.Th style={{ width: "1%" }}></Table.Th>
          <Table.Th style={{ width: "1%" }}></Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {games.map((g) => (
          <Table.Tr key={g.id}>
            <Table.Td>{g.name.replace("Spiel ", "")}</Table.Td>

            <Table.Td style={{ whiteSpace: "nowrap" }}>
              {DateTime.fromISO(g.dateTime).toFormat("ccc., HH:mm")}
            </Table.Td>
            <Table.Td style={{ whiteSpace: "nowrap" }}>
              {g.actualTeams.homeTeamId && g.actualTeams.guestTeamId ? (
                <Flex align={"center"} wrap="nowrap">
                  <Anchor
                    component={Link}
                    to={`/teams/${g.actualTeams.homeTeamId}`}
                    underline="never"
                  >
                    <Flex pr={5} align="center">
                      <Box w={25}>
                        <TeamLogo
                          height={25}
                          teamId={g.actualTeams.homeTeamId}
                        />
                      </Box>
                    </Flex>
                  </Anchor>
                  &nbsp;–&nbsp;
                  <Anchor
                    component={Link}
                    to={`/teams/${g.actualTeams.guestTeamId}`}
                    underline="never"
                  >
                    <Flex pl={5} align="center">
                      <Box w={25}>
                        <TeamLogo
                          height={25}
                          teamId={g.actualTeams.guestTeamId}
                        />
                      </Box>
                    </Flex>
                  </Anchor>
                </Flex>
              ) : (
                <Flex align="center" wrap="nowrap">
                  {g.actualTeams.homeTeamId ? (
                    <Anchor
                      component={Link}
                      to={`/teams/${g.actualTeams.homeTeamId}`}
                      underline="never"
                    >
                      <Flex pr={5} align="center">
                        <Box w={25}>
                          <TeamLogo
                            height={25}
                            teamId={g.actualTeams.homeTeamId}
                          />
                        </Box>
                      </Flex>
                    </Anchor>
                  ) : (
                    <ResolvedTeamReference
                      teamReference={g.plannedTeams.home}
                      competitionId={g.competitionId}
                    />
                  )}
                  {g.actualTeams.homeTeamId || g.actualTeams.guestTeamId ? (
                    <>&nbsp;–&nbsp;</>
                  ) : (
                    <br />
                  )}
                  {g.actualTeams.guestTeamId ? (
                    <Anchor
                      component={Link}
                      to={`/teams/${g.actualTeams.guestTeamId}`}
                      underline="never"
                    >
                      <Flex pl={5} align="center">
                        <Box w={25}>
                          <TeamLogo
                            height={25}
                            teamId={g.actualTeams.guestTeamId}
                          />
                        </Box>
                      </Flex>
                    </Anchor>
                  ) : (
                    <ResolvedTeamReference
                      teamReference={g.plannedTeams.guest}
                      competitionId={g.competitionId}
                    />
                  )}
                </Flex>
              )}
            </Table.Td>

            {g.started && (
              <>
                <Table.Td style={{ textAlign: "center", whiteSpace: "nowrap" }}>
                  {g.score.home}:{g.score.guest}
                  {g.shootOutStarted && (
                    <>
                      {" "}
                      (
                      {g.score.home +
                        g.shootOutShots.filter(
                          (s) =>
                            s.teamId === g.actualTeams.homeTeamId && s.success,
                        ).length}
                      :
                      {g.score.guest +
                        g.shootOutShots.filter(
                          (s) =>
                            s.teamId === g.actualTeams.guestTeamId && s.success,
                        ).length}
                      )
                    </>
                  )}
                </Table.Td>

                {!g.result ? (
                  <Table.Td ta="right">
                    <Badge color="red" w={50}>
                      live
                    </Badge>
                  </Table.Td>
                ) : (
                  <Table.Td>
                    <Flex justify="flex-end" gap={6}>
                      <ActionIcon
                        component={g.links.youtube ? "a" : undefined}
                        href={g.links.youtube ?? undefined}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="fwcBlue"
                        variant={g.links.youtube ? "light" : "filled"}
                        size="sm"
                        disabled={!g.links.youtube}
                      >
                        <IconBrandYoutube />
                      </ActionIcon>
                      <ActionIcon
                        component={g.links.gallery ? "a" : undefined}
                        href={g.links.gallery ?? undefined}
                        target="_blank"
                        rel="noopener noreferrer"
                        color="fwcBlue"
                        size="sm"
                        variant={g.links.gallery ? "light" : "filled"}
                        disabled={!g.links.gallery}
                      >
                        <IconPhoto />
                      </ActionIcon>
                    </Flex>
                  </Table.Td>
                )}
              </>
            )}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};
